(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-product-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ck-story').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';root.querySelectorAll('[data-gallery]').forEach(button=>button.addEventListener('click',()=>{const img=root.querySelector('.hero figure>img');img.removeAttribute('srcset');img.src=button.dataset.gallery==='hero'?root.dataset.heroImage:root.dataset.angleImage;root.querySelectorAll('[data-gallery]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));const quote=root.querySelector('#quote'),counter=root.querySelector('#quote-count');if(quote&&counter)quote.addEventListener('input',()=>{counter.textContent=quote.value.length+' / 90';});root.querySelectorAll('[data-design]').forEach(button=>button.addEventListener('click',()=>{const isQuote=button.dataset.design==='quote',img=root.querySelector('#design-image');img.removeAttribute('srcset');img.src=isQuote?root.dataset.quoteImage:root.dataset.nameImage;img.alt=isQuote?root.dataset.quoteAlt:root.dataset.nameAlt;root.querySelectorAll('[data-design]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
